var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconRepair48Filled = function SvgIconRepair48Filled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.74 18.73a2 2 0 0 0-1.37-1.61 2.08 2.08 0 0 0-2.11.5l-3.85 3.85a.33.33 0 0 1-.34.09l-2.66-.73a.33.33 0 0 1-.24-.24l-.73-2.66a.33.33 0 0 1 .09-.34l3.85-3.85a2.06 2.06 0 0 0 .5-2.11 2 2 0 0 0-1.61-1.37 10.11 10.11 0 0 0-11.06 13.25l-6.76 6.75a4.444 4.444 0 0 0 6.28 6.29l6.76-6.76a10.11 10.11 0 0 0 13.25-11.06Z",
    fill: "current"
  })));
};
export default SvgIconRepair48Filled;